import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    margin: 5,
    fontSize: 16,
    letterSpacing: "0.44px",
  },
}));

export default useStyles;
